import { BaseComponent } from './base.component';

export abstract class ControlValueAccessorComponent extends BaseComponent {
  protected _onChange = (_: any) => {};
  protected _onTouched = () => {};

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  onChange(event: any): void {
    this._onChange(event?.target?.value);
  }
  onBlur(event: any): void {
    this._onTouched();
  }

  writeValue(obj: any): void {}
  setDisabledState?(isDisabled: boolean): void {}
}
